// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortNouns } from "./common-short-fields";

export const platformAdminAssetsObjectSpaces = {
  columns: {
    displayName: "显示名称",
    writePolicy: "写入权限",
    status: commonShortNouns.status,
    assetCount: "资产数",
    capacity: "容量",
    quota: "配额",
    latestWrite: "最新写入",
    granteeType: "授权对象类型",
    grantee: "授权对象",
    accessLevel: "权限",
  },
  actions: {
    createSpacePolicy: "纳管对象空间",
    editPolicy: "编辑写入权限",
    onboardGovernance: "纳入治理",
    grant: "授权",
    createGrant: "新建授权",
    removeGrant: "删除",
  },
  drawer: {
    assetGovernance: "资产治理详情 · {name}",
    assetGovernanceShort: "资产治理详情",
    deleteProtection: "删除保护",
    references: "引用明细",
    referencesSubtitle: "当前资产引用真相直接来自 asset-center，不再由业务系统自行推导。",
    grantTitle: "对象空间授权 · {name}",
    grantTitleShort: "对象空间授权",
    grantSummary: "授权摘要",
    grantRules: "授权规则",
  },
  objects: {
    objectSpaceGrant: "对象空间授权",
  },
  fields: {
    deleteStatus: "删除状态",
    referenceCount: "引用数量",
    businessReferenceCount: "业务引用数量",
    businessReferenceSnapshotCount: "历史来源提示",
    objectSpace: "对象空间",
    quota: "配额上限",
    storageBackend: "存储后端",
    spacePolicy: "写入权限",
    spaceStatus: "空间状态",
    grantCount: "授权数",
    blockingReasons: "阻断原因",
    governanceWarnings: "治理告警",
  },
  form: {
    objectSpacePolicyTitle: "对象空间治理 · {name}",
    objectSpacePolicyCreate: "纳管对象空间",
    objectSpaceKey: "对象空间键",
    objectSpaceKeyRequired: "请输入对象空间键",
    displayName: "显示名称",
    scopeType: "作用域类型",
    scopeTypeRequired: "请选择作用域类型",
    scopeValue: "作用域值",
    scopeValueRequired: "请输入作用域值",
    writePolicy: "写入权限",
    writePolicyRequired: "请选择写入权限",
    quotaGb: "空间配额",
    quotaGbPlaceholder: "留空表示不限",
    quotaGbHelp: "按 GB 配置该对象空间的总配额；留空表示不限。",
    status: commonShortNouns.status,
    statusRequired: "请选择状态",
    grantCreateTitle: "新建对象空间授权 · {name}",
    grantCreateTitleShort: "新建对象空间授权",
    grantTargetType: "授权对象类型",
    grantTargetTypeRequired: "请选择授权对象类型",
    grantTarget: "授权对象",
    grantTargetRequired: "请输入授权对象",
    accessLevel: "权限级别",
    accessLevelRequired: "请选择权限级别",
    removeGrantTitle: "删除授权",
    removeGrantDescription: "确认删除 {type}:{value} 吗？",
    noSelectedSpace: "未选择对象空间",
  },
  errors: {
    partialLoadFailed: "资产中心部分数据读取失败（{count} 个请求未成功）",
    grantLoadFailed: "对象空间授权读取失败",
    grantRemoveFailed: "删除对象空间授权失败",
    policyUpdateFailed: "对象空间策略更新失败",
    policyCreateFailed: "对象空间策略创建失败",
    grantCreateFailed: "对象空间授权创建失败",
  },
} as const;
